import { Box, IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { getProductTypeByValue, getProductUOMByName } from "../../constants/enums";


const productsColumns = ( handleEdit, handleDelete, colors) => [
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    cellClassName: "name-column--cell",
  },
  {
    field: "UOM",
    headerName: "Unidad de medida",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
    renderCell: (params) => {
      return getProductUOMByName(params.value).label;
    }
  },
  {
    field: "total_quantity",
    headerName: "Cantidad",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
    renderCell: (params) => {
      return params.value ? params.value : 'N/A'
    }
  },
  {
    field: "average_cost",
    headerName: "Precio promedio",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
    renderCell: (params) => {
      return params.value ? `$${params.value}` : 'N/A'
    }
  },
  {
    field: "last_added_cost",
    headerName: "Último Precio",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 1,
    renderCell: (params) => {
      return params.value ? `$${params.value}` : 'N/A'
    }
  },
  {
    field: "type",
    headerName: "Tipo",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const typeInfo = getProductTypeByValue(params.value);

      return (
      <Box
        sx={{
          color: typeInfo.color,
          fontWeight: "bold",
          backgroundColor: `${typeInfo.color}30`, // Transparent background
          border: ` ${typeInfo.color}`, // Corner borders
          borderRadius: "8px", // Rounded corners
          padding: "8px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: "40%",
          height: "50%",
          textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
          overflow: "hidden", // Prevent shadow from going outside the box
        }}
      >
        {typeInfo.label}
      </Box>
      );
    },
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 0.4,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleEdit(params.row.id)} sx={{ color: colors.grey[100] }}>
          <EditOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => handleDelete(params.row.id)} sx={{ color: colors.grey[100] }}>
          <DeleteOutlinedIcon />
        </IconButton>
      </Box>
    ),
  },
];

export { productsColumns }